import { type ExtractPropTypes, computed, type PropType } from 'vue';

import { type ColorType, colorList } from '../../typings/colorType';

export function withColorProps(defaultValue?: ColorType) {
  return {
    /**
     * Kolor
     */
    color: {
      type: String as PropType<ColorType>,
      default: defaultValue
    }
  };
}

/**
 * Zwraca klasę koloru
 *
 * @export
 * @param {string} prefix
 * @param {ExtractPropTypes<typeof withColorProps>} props
 * @return {*}  {Record<string, boolean>}
 */
export const useColorProps = (prefix: string, props: ExtractPropTypes<ReturnType<typeof withColorProps>>) => {
  return computed(() => ({
    [`${prefix}--${props.color}`]: props.color !== undefined
  }));
};

/**
 * Konfiguracja dla storybooka
 */
export const storiesColorArgs = {
  args: {
    color: undefined
  },

  argTypes: {
    color: {
      options: colorList,
      control: { type: 'select' }
    }
  }
};
